"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _core.makeStyles)(theme => ({
  employee: {
    alignItems: "center",
    background: theme.palette.background.light,
    marginBottom: theme.spacing(4),
    padding: theme.spacing(4, 3)
  },
  employeeTitle: {
    ...theme.customTypography.teamEmployeeTitle
  },
  image: {
    borderRadius: "50%",
    display: "block",
    height: "100%",
    margin: "0 auto",
    maxHeight: 240,
    maxWidth: 240,
    objectFit: "cover",
    width: "100%"
  },
  imagePlaceholder: {
    background: "rgba(255, 255, 255, 0.6)",
    borderRadius: "50%",
    height: 120,
    width: 120
  },
  contentWrapper: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  }
}));
const Employee = _ref => {
  let {
    firstName,
    groups,
    lastName,
    media,
    profilePicture
  } = _ref;
  const css = useStyles();
  let name = null;
  if (firstName && lastName) {
    name = firstName + " " + lastName;
  } else if (firstName) {
    name = firstName;
  } else if (lastName) {
    name = lastName;
  }
  const m = profilePicture ? profilePicture : (0, _lodash.first)(media);
  let image = null;
  if (m && m.filename) {
    image = /*#__PURE__*/_react.default.createElement("img", {
      className: css.image,
      src: m.filename,
      alt: name,
      loading: "lazy"
    });
  } else {
    image = /*#__PURE__*/_react.default.createElement("div", {
      className: css.imagePlaceholder
    });
  }
  const jobTitlesAsString = groups === null || groups === void 0 ? void 0 : groups.map(item => {
    return item.addition;
  }).join(", ");
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.employee
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 4
  }, image), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 8,
    className: css.contentWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.employeeTitle,
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: jobTitlesAsString
    }
  }))));
};
var _default = exports.default = Employee;